import { showToast } from "./notification_toast";

function openPopup(badgeData) {
  document.body.insertAdjacentHTML('beforeend', getModalContent(badgeData));
  
  // Initialize read more functionality
  initializeReadMore();
  
  // Initialize set default button
  initializeSetDefaultButton();
  
  ["close-modal"].forEach(linkClass => {
    let links = document.querySelectorAll("." + linkClass);
    links.forEach(link => {
      link.addEventListener("click", () => {
        if (window.innerWidth < 768) {
          toggleModal(true, true);
        } else {
          toggleModal(false, true);
        }
      });
    });
  });

  if (window.innerWidth < 768) {
    toggleModal(true, false);
  } else {
    toggleModal(false, false);
  }
}

// onHidden is optional and only used by the Activity Badge Visibility flows
// below; existing two-argument callers behave exactly as before.
function toggleModal(isMobile, isOpen, onHidden) {
  let badgeModal = document.getElementById("badge-modal");
  let badgeDrawer = document.getElementById("badge-drawer");
  let target = isMobile ? badgeDrawer : badgeModal;
  let options = isMobile ? {
    placement: 'bottom',
    backdrop: true,
    bodyScrolling: false,
    edge: false,
    edgeOffset: '',
    backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-[700]',
    onHide: () => {
      badgeDrawer.style.transform = "translateY(100%)";
        setTimeout(() => {
          badgeDrawer.style.display = "none";
          badgeDrawer.remove();
        }, 200);
      if (typeof onHidden === "function") onHidden();
    },
    onShow: () => {
        badgeDrawer.style.display = "block";
        badgeDrawer.style.transform = "translateY(0%)";
    },
    onToggle: () => {},
  } : {
    backdrop: 'dynamic',
    backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-[700]',
    closable: true,
    onHide: () => {
      badgeModal.remove();
      if (typeof onHidden === "function") onHidden();
    },
    onShow: () => {},
    onToggle: () => {},
  };
	let instanceOptions = {
	  id: isMobile ? 'badge-drawer' : 'badge-modal',
	  override: true
	};
	let instance = isMobile ? new Drawer(target, options, instanceOptions) : new Modal(target, options, instanceOptions);
  if (isOpen) {
    instance.hide();
  } else {
    instance.show();
  }
}


function getModalContent(badgeData) {
  const badgeName = badgeData?.name || 'Badge';
  const badgeDescription = badgeData?.description || 'Achievement unlocked!';
  const badgeIcon = badgeData?.icon || `https://${window.appconfig.cdn_hosts[3]}/static/badge/automated/Hotspot-Level3.png`;
  const isUnlocked = badgeData?.unlocked === 'true';
  const userCount = badgeData?.userCount || 0;
  
  const content = `
    <div class="flex justify-center items-center flex-col relative overflow-hidden">
      <button type="button" class="close-modal absolute top-1 right-1 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white z-20">
        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
        </svg>
      </button>
      
      <div class="z-[1] mt-[20px] font-bold text-primary-text-light dark:text-primary-text-dark text-3xl text-center break-words leading-tight pr-8">${badgeName}</div>
      
      <div class="z-[1] text-primary-text-light dark:text-primary-text-dark mb-4 text-base text-center break-words leading-relaxed max-w-sm">
        <div id="badge-description-container">
          <span id="badge-description" class="line-clamp-3">${badgeDescription}</span>
          <button id="read-more-btn" class="text-primary hover:underline text-sm ml-1 hidden">...${I18n.t('read_more')}</button>
        </div>
      </div>
      
      <div class="relative inline-block mb-6 mt-4">
        <img src="${badgeIcon}" width="145px" height="145px" class="relative z-[1]" style="filter: ${!isUnlocked ? 'grayscale(1)' : 'none'};" />
        
        ${isUnlocked ? `<!-- Lottie Animation - Top Right of Badge Image -->
        <dotlottie-player 
          src="https://lottie.host/e2bacfbb-ca1d-4e8f-87b9-3d858ab2f3b6/4R9dWYsTO1.lottie" 
          background="transparent" 
          speed="1" 
          style="width: 150px; height: 150px; position: absolute; top: -30px; right: -30px; z-index: 800; pointer-events: none;" 
          loop 
          autoplay>
        </dotlottie-player>` : ''}
      </div>
      
      <div class="z-[1] font-bold text-primary-text-light text-center dark:text-primary-text-dark text-3xl">
        <svg width="50" height="50" height="50" viewBox="0 0 24 24" class="align-text-bottom mr-1 block" aria-hidden="true">
          <path d="M2.29,16.43v-1.03c.02-.59.35-1.12.88-1.38.7-.39,1.49-.58,2.29-.54.16,0,.31,0,.47.01.16,0,.32.03.48.06-.16.25-.28.53-.37.82-.08.28-.12.58-.12.87v1.19h-3.64ZM7.35,16.43v-1.16c0-.39.11-.77.33-1.08.25-.35.58-.65.96-.86.46-.26.96-.45,1.48-.55.61-.13,1.24-.19,1.87-.18.63,0,1.27.06,1.89.18.52.1,1.02.29,1.48.55.38.21.71.5.96.86.22.32.33.7.33,1.08v1.16H7.35ZM18.07,16.43v-1.19c0-.3-.04-.6-.11-.9-.07-.28-.19-.55-.34-.8.16-.03.32-.05.47-.06.15,0,.3-.01.45-.01.8-.04,1.59.15,2.29.54.53.27.87.8.88,1.39v1.03h-3.64ZM5.46,12.65c-.38,0-.75-.15-1.02-.42-.28-.27-.43-.64-.42-1.02,0-.38.15-.75.42-1.02.27-.27.64-.42,1.02-.42.38,0,.75.14,1.02.42.28.27.43.64.42,1.02,0,.38-.15.75-.42,1.02-.27.28-.64.44-1.03.43ZM18.55,12.65c-.38,0-.75-.15-1.02-.43-.28-.27-.43-.63-.43-1.02,0-.39.15-.76.43-1.02.27-.27.64-.42,1.02-.42.39,0,.76.14,1.03.42.27.27.42.64.42,1.02,0,.38-.14.75-.42,1.02-.27.28-.64.43-1.03.42ZM12,11.96c-.58.01-1.15-.22-1.55-.64-.42-.41-.65-.97-.64-1.55-.01-.59.22-1.15.64-1.56.41-.41.97-.64,1.55-.63.59-.01,1.15.21,1.56.63.42.41.64.97.63,1.56.01.58-.22,1.14-.63,1.55-.41.42-.97.66-1.56.64Z" transform="translate(1, 1)" fill="currentColor"/>
        </svg>
        <span>${userCount.toLocaleString()}</span>
      </div>
      <div class="z-[1] text-primary-text-light dark:text-primary-text-dark text-sm mb-4">${I18n.t('users_earned_this_badge')}</div>
      
      ${getSetDefaultButton(badgeData)}
      
      <div class="z-[0] rounded-tr-[50%] rounded-tl-[50%] absolute w-[140%] h-full bg-primary-dd opacity-[.1] top-[50%] left-1/2 -translate-x-1/2 pointer-events-none"></div>
    </div>
  `;

  if (window.innerWidth < 768) {
    return `<div id="badge-drawer" style="display:none" class="overflow-hidden fixed bottom-0 left-0 right-0 z-[800] w-full rounded-t-[20px] overflow-y-auto bg-white dark:bg-background-dark translate-y-[100%] transition-transform" tabindex="-1" aria-labelledby="drawer-bottom-label">
        ${content}
      </div>`;
  } else {
    return `<div id="badge-modal" tabindex="-1" class="fixed top-0 left-0 right-0 z-[800] hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
      <div class="relative w-full max-w-md max-h-full">
          <div class="common-box relative shadow md:w-[450px] w-[95%] mx-auto overflow-hidden">
            ${content}
          </div>
      </div>
    </div>`
  }
}

function getSetDefaultButton(badgeData) {
  const isUnlocked = badgeData?.unlocked === 'true';
  const badgeId = badgeData?.id;
  const badgeIcon = badgeData?.icon;
  
  if (!isUnlocked) return '';
  
  // Only show selection button if user can select badges (viewing own profile)
  if (!window.canSelectBadges) return '';
  
  const isCurrentDefault = window.currentSelectedBadgeId?.toString() === badgeId;
  
  if (isCurrentDefault) {
    return `<div class="z-[1] bg-transparent text-primary border border-primary rounded-bradius10 w-max py-2 px-3 mb-[20px] text-sm whitespace-nowrap cursor-not-allowed">${I18n.t('selected_badge')}</div>`;
  }
  
  return `<div class="z-[1] make-default cursor-pointer select-badge bg-primary w-max mb-[20px] text-white py-2 px-3 rounded-md text-sm whitespace-nowrap" 
           data-id="badge_selection_${badgeId}" 
           data-badge-id="${badgeId}" 
           data-badge-url="${badgeIcon}">
    ${I18n.t('make_as_default')}
  </div>`;
}

// Optimized: Green tick functionality
function addSelectedBadgeTick(badgeId) {
  document.querySelectorAll('.selected-badge-tick').forEach(tick => tick.remove());
  
  // Only show green tick if user can select badges (viewing own profile)
  if (!window.canSelectBadges) return;
  
  const badgeElement = document.querySelector(`[data-badge-id="${badgeId}"]`);
  if (!badgeElement) return;
  
  const tick = document.createElement('div');
  tick.className = 'selected-badge-tick absolute top-[5px] md:right-[45px] right-[30px] w-6 h-6 bg-green-500 rounded-full flex items-center justify-center z-10';
  tick.innerHTML = `<svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
  </svg>`;
  
  if (getComputedStyle(badgeElement).position === 'static') {
    badgeElement.style.position = 'relative';
  }
  
  badgeElement.appendChild(tick);
}

// Set default button - uses event delegation to avoid listener cleanup issues
function initializeSetDefaultButton() {
  // No-op: delegation handles all .select-badge clicks
}

// Handles .select-badge click via delegation
async function handleSelectBadgeClick(btn) {
  if (btn.dataset.processing === 'true') return;
  btn.dataset.processing = 'true';
  
  const badgeId = btn.getAttribute('data-badge-id');
  const radioBtnId = btn.getAttribute('data-id');
  const badgeUrl = btn.getAttribute('data-badge-url');
  
  const originalText = btn.textContent;
  btn.textContent = 'Setting...';
  btn.style.pointerEvents = 'none';
  
  try {
    if (typeof userSelectionStore === 'function') {
      userSelectionStore(badgeId, null, radioBtnId, badgeUrl);
      handleSelectBadgeSuccess(btn, badgeId);
    } else {
      document.querySelectorAll('.badges_ranks_loader_container').forEach(loader => {
        loader.style.display = 'block';
      });
      
      const response = await fetch(`/profile/badge_selection?${new URLSearchParams({
        badge_id: badgeId,
        reputation_level_id: null,
        radio_id: radioBtnId,
        badge_url: badgeUrl
      })}`, {
        method: 'GET',
        headers: { 
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      });
      
      if (response.ok) {
        const result = await response.json();
        if (result.status === 'success') {
          handleSelectBadgeSuccess(btn, badgeId);
        } else {
          console.error('Badge selection failed:', result.message);
          handleSelectBadgeError(btn, originalText);
        }
      } else {
        console.error('Badge selection failed:', response.status, response.statusText);
        handleSelectBadgeError(btn, originalText);
      }
    }
  } catch (error) {
    console.error('Error setting badge as default:', error);
    handleSelectBadgeError(btn, originalText);
  }
}

function handleSelectBadgeSuccess(btn, badgeId) {
  document.querySelectorAll('.badges_ranks_loader_container').forEach(loader => {
    loader.style.display = 'none';
  });
  
  window.currentSelectedBadgeId = parseInt(badgeId);
  btn.style.display = 'none';
  btn.dataset.processing = 'false';
  
  if (window.innerWidth < 768) {
    toggleModal(true, true);
  } else {
    toggleModal(false, true);
  }
  
  addSelectedBadgeTick(badgeId);
}

function handleSelectBadgeError(btn, originalText) {
  document.querySelectorAll('.badges_ranks_loader_container').forEach(loader => {
    loader.style.display = 'none';
  });
  
  btn.textContent = originalText;
  btn.style.pointerEvents = 'auto';
  btn.dataset.processing = 'false';
}

function initializeReadMore() {
  const containerEl = document.getElementById('badge-description-container');
  const descriptionEl = document.getElementById('badge-description');
  const readMoreBtn = document.getElementById('read-more-btn');
  
  if (!containerEl || !descriptionEl || !readMoreBtn) return;
  
  const originalText = descriptionEl.textContent;
  
  setTimeout(() => {
    const lineHeight = parseInt(window.getComputedStyle(descriptionEl).lineHeight);
    const maxHeight = lineHeight * 3;
    
    if (descriptionEl.scrollHeight > maxHeight) {
      readMoreBtn.classList.remove('hidden');
      
      let isExpanded = false;
      readMoreBtn.addEventListener('click', () => {
        if (isExpanded) {
          descriptionEl.className = 'line-clamp-3';
          descriptionEl.textContent = originalText;
          readMoreBtn.textContent = '...' + I18n.t('read_more');
          readMoreBtn.classList.remove('hidden');
        } else {
          descriptionEl.className = '';
          descriptionEl.innerHTML = originalText + ' <button class="text-primary hover:underline text-sm ml-1" onclick="this.parentElement.parentElement.querySelector(\'#read-more-btn\').click()">' + I18n.t('less') + '</button>';
          readMoreBtn.classList.add('hidden');
        }
        isExpanded = !isExpanded;
      });
    }
  }, 100);
}

// Main initialization - uses event delegation for dynamic elements
function setBadgePopup() {
  // Single delegated listener for .select-badge (handles popup + page-level buttons)
  if (!window._badgeSelectDelegated) {
    window._badgeSelectDelegated = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.select-badge');
      if (btn) {
        e.preventDefault();
        handleSelectBadgeClick(btn);
      }
    });
  }
  
  // Single delegated listener for .badge-open-popup
  if (!window._badgePopupDelegated) {
    window._badgePopupDelegated = true;
    document.addEventListener('click', (e) => {
      const element = e.target.closest('.badge-open-popup');
      if (element) {
        const badgeData = {
          id: element.dataset.badgeId,
          name: element.dataset.badgeName,
          description: element.dataset.badgeDescription,
          icon: element.dataset.badgeIcon,
          count: element.dataset.badgeCount,
          unlocked: element.dataset.badgeUnlocked,
          unlockDate: element.dataset.badgeUnlockDate,
          userCount: element.dataset.badgeUserCount,
          category: element.dataset.badgeCategory,
          recordType: element.dataset.badgeRecordType
        };
        openPopup(badgeData);
      }
    });
  }
  
  setTimeout(() => {
    if (window.currentSelectedBadgeId) {
      addSelectedBadgeTick(window.currentSelectedBadgeId);
    }
  }, 1000);
}

// Global userSelectionStore function for compatibility
function userSelectionStore(badge_id, reputation_level_id, radio_btn_id, badge_url) {
  document.querySelectorAll('.badges_ranks_loader_container').forEach(loader => {
    loader.style.display = 'block';
  });
  fetchAPI('/profile/badge_selection', 'GET', {
    badge_id,
    reputation_level_id,
    radio_id: radio_btn_id,
    badge_url
  }, 'script');
}

// ---------------------------------------------------------------------------
// Activity Badge Visibility (Phase 1)
// Flow A - progress nudges, Flow B - badge-earned congrats.
// Everything below reuses the modal/drawer plumbing above (toggleModal, the
// same #badge-modal / #badge-drawer ids); the click-to-open badge popup on the
// profile page is untouched.
// ---------------------------------------------------------------------------
const BADGE_VISIBILITY_RECHECK_DELAY = 2500;
// Both the dialog's aria-labelledby and the heading it points at are built
// from this, so they cannot drift apart.
const BADGE_VISIBILITY_TITLE_ID = "badge-visibility-title";

let badgeVisibilityQueue = [];
let badgeVisibilityOpen = false;
let badgeVisibilityRecheckTimer = null;
let badgeVisibilityRecheckInFlight = false;
let badgeVisibilityLastFocus = null;

function initBadgeVisibility() {
  const node = document.getElementById("BadgeVisibilityData");
  // No marker means the feature is off (or the visitor is a guest) - bind nothing.
  if (!node) return;

  try {
    enqueueBadgeVisibility(JSON.parse(node.dataset.items || "[]"));
  } catch (error) {
    // A malformed payload must never break the topic page.
  }
  bindBadgeVisibilityRecheck();
}

// Warm the CDN cache for every queued badge as soon as the payload arrives.
// The <link rel="preload"> in the view covers the first item on a page load;
// this covers the rest of the queue and everything the post-vote re-check
// brings back, neither of which exist at parse time.
function preloadBadgeImages(items) {
  items.forEach((item) => {
    const src = String(item && item.badge_image ? item.badge_image : "").trim();
    if (src) new Image().src = src;
  });
}

function enqueueBadgeVisibility(items) {
  if (!Array.isArray(items) || !items.length) return;
  preloadBadgeImages(items);
  badgeVisibilityQueue = badgeVisibilityQueue.concat(items);
  showNextBadgeVisibilityItem();
}

// Multiple pending items render one after another, never stacked.
function showNextBadgeVisibilityItem() {
  if (badgeVisibilityOpen) return;
  const item = badgeVisibilityQueue.shift();
  if (!item) return;
  badgeVisibilityOpen = true;
  openBadgeVisibilityPopup(item);
}

// Idempotent: both the close button and a backdrop dismiss land here.
function onBadgeVisibilityClosed() {
  if (!badgeVisibilityOpen) return;
  badgeVisibilityOpen = false;
  restoreBadgeVisibilityFocus();
  setTimeout(showNextBadgeVisibilityItem, 300);
}

// The modal opens unprompted, so focus has to be handed to it and handed back
// on close - otherwise a keyboard user is left tabbing through a page hidden
// behind the backdrop.
function restoreBadgeVisibilityFocus() {
  const previous = badgeVisibilityLastFocus;
  badgeVisibilityLastFocus = null;
  if (previous && document.contains(previous)) previous.focus({ preventScroll: true });
}

// The badge art comes off a CDN that can take a second even preconnected, so
// the slot holds a skeleton until it arrives. Marking the row is what reveals
// the shine too: its mask is that same image, and an unloaded mask renders as
// an unmasked white bar.
function bindBadgeArtLoading(root) {
  const art = root.querySelector(".badge-nudge-art");
  if (!art) return;

  const img = art.querySelector(".badge-nudge-badge-img");
  if (!img) return;

  const loaded = () => art.classList.add("is-loaded");
  const failed = () => {
    // Nothing to reveal and nothing to mask - drop both rather than leave a
    // shimmering placeholder for an image that is never coming.
    art.querySelectorAll(".badge-nudge-skeleton, .badge-nudge-shine")
       .forEach((el) => el.remove());
  };

  // A cached image can already be complete before this runs, in which case no
  // load event will fire. naturalWidth distinguishes decoded from broken.
  if (img.complete) {
    img.naturalWidth > 0 ? loaded() : failed();
    return;
  }

  img.addEventListener("load", loaded, { once: true });
  img.addEventListener("error", failed, { once: true });
}

function openBadgeVisibilityPopup(item) {
  const isMobile = window.innerWidth < 768;
  badgeVisibilityLastFocus = document.activeElement;
  document.body.insertAdjacentHTML("beforeend", badgeVisibilityMarkup(item, isMobile));

  const root = document.getElementById(isMobile ? "badge-drawer" : "badge-modal");
  if (!root) {
    badgeVisibilityOpen = false;
    badgeVisibilityLastFocus = null;
    return;
  }

  root.querySelectorAll(".close-modal, .badge-visibility-cta").forEach((el) => {
    el.addEventListener("click", () => toggleModal(isMobile, true, onBadgeVisibilityClosed));
  });

  const shareBtn = root.querySelector(".badge-visibility-share");
  if (shareBtn) shareBtn.addEventListener("click", () => shareBadgeVisibility(item));

  // Explicit WhatsApp / Facebook intents (PRD 5.4). The href is built here
  // rather than in the markup so the share URL is normalised exactly once.
  root.querySelectorAll(".badge-visibility-share-intent").forEach((link) => {
    link.setAttribute("href", shareIntentUrl(link.dataset.network, item));
    link.addEventListener("click", () => trackBadgeShare(item, link.dataset.network));
  });

  bindBadgeArtLoading(root);

  // Swipe down to dismiss (PRD "Rules & Behavior"). Drawer only - the desktop
  // modal has no swipe affordance.
  if (isMobile) bindBadgeVisibilitySwipe(root);

  toggleModal(isMobile, false, onBadgeVisibilityClosed);

  const closeBtn = root.querySelector(".close-modal");
  if (closeBtn) closeBtn.focus({ preventScroll: true });

  const isCongrats = item.type === "badge_earned";
  trackBadgeEvent(isCongrats ? "badge_congrats_shown" : "badge_nudge_shown", {
    badge_name: item.badge_name,
    record_type: item.record_type,
    nudge_type: item.type
  });
}

// Success metrics, plus the event source for the WebEngage notification track.
// analyticsTrack routes to GTM or Yandex Metrica only (see analytics_tracker.js),
// so WebEngage - which drives the push and re-engagement email campaigns - has
// to be handed the event explicitly. The campaigns themselves are dashboard
// configuration, not code.
// Payload is badge/category only, deliberately: no user identifiers.
function trackBadgeEvent(eventName, payload) {
  if (typeof window.analyticsTrack === "function") {
    window.analyticsTrack(eventName, payload);
  }
  if (window.webengage && typeof window.webengage.track === "function") {
    try {
      window.webengage.track(eventName, payload);
    } catch (error) {
      // Analytics is never worth breaking the modal for.
    }
  }
}

// Follows the finger downward and dismisses past the threshold, otherwise
// springs back. Listeners live on the drawer node itself, which toggleModal's
// onHide removes, so they go with it - nothing to unbind.
const BADGE_VISIBILITY_SWIPE_THRESHOLD = 80;

function bindBadgeVisibilitySwipe(root) {
  let startY = null;
  let deltaY = 0;

  root.addEventListener("touchstart", (event) => {
    // Ignore multi-touch (pinch/zoom) - only a single-finger drag is a swipe.
    if (event.touches.length !== 1) return;
    // The sheet is capped at 90vh, so on a short viewport its content
    // scrolls. Only treat a drag as a dismiss when the content is already at
    // the top, otherwise scrolling back up would drag the sheet away instead.
    if (root.scrollTop > 0) return;
    startY = event.touches[0].clientY;
    deltaY = 0;
    root.style.transition = "none";
  }, { passive: true });

  root.addEventListener("touchmove", (event) => {
    if (startY === null || event.touches.length !== 1) return;
    deltaY = event.touches[0].clientY - startY;
    // Downward only; an upward drag must not lift the drawer off its edge.
    if (deltaY <= 0) return;
    root.style.transform = `translateY(${deltaY}px)`;
  }, { passive: true });

  root.addEventListener("touchend", () => {
    if (startY === null) return;
    startY = null;
    // Restore the class-driven transition either way, so both the dismiss
    // animation and the spring-back are animated.
    root.style.transition = "";
    if (deltaY > BADGE_VISIBILITY_SWIPE_THRESHOLD) {
      toggleModal(true, true, onBadgeVisibilityClosed);
    } else {
      root.style.transform = "translateY(0%)";
    }
    deltaY = 0;
  }, { passive: true });
}

// The payload is server-built (badge names, i18n copy, counts), but it is
// interpolated into markup, so escape every value before it lands in the DOM.
function escapeBadgeText(value) {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

// The locale strings lead with an emoji ("👍 Upvote deals you love"), which the
// design renders as its own icon column. Split it off; anything that does not
// start with a non-ASCII glyph renders as plain text with no icon.
function badgeWayParts(way) {
  const match = String(way).match(/^(\S+)\s+(.+)$/);
  if (match && /[^\x00-\x7F]/.test(match[1])) {
    return { icon: match[1], text: match[2] };
  }
  return { icon: "", text: way };
}

// Path exported from the Figma source (node 31:53). fill is currentColor
// rather than the design's literal so each platform's `primary` applies.
const BADGE_SPARKLE_SVG =
  '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10 0L12.4749 7.52513L20 10L12.4749 12.4749L10 20L7.52513 12.4749L0 10L7.52513 7.52513L10 0Z"/></svg>';

// Congrats copy reads "You have earned <badge> badge by ..." with the badge
// name bolded inside the sentence (Figma 31:27). The payload carries one flat
// string, so bold the badge name where it appears rather than splitting the
// key into fragments that every locale would have to reassemble.
function badgeMessageMarkup(item) {
  const message = escapeBadgeText(item.message);
  const name = escapeBadgeText(item.badge_name);
  if (!name || !message.includes(name)) return message;

  const at = message.indexOf(name);
  return `${message.slice(0, at)}<strong class="font-bold">${name}</strong>${message.slice(at + name.length)}`;
}

// Same one-shot burst the gift-store success page uses. <dotlottie-player> is
// registered globally in the layout, so no extra script tag is needed here.
const BADGE_CONFETTI_LOTTIE =
  "https://lottie.host/9fc9caf0-a740-4e2e-a505-084f940ed272/gGKf7XXYwG.lottie";

// WhatsApp brand mark - a frozen brand-identity accent, the exception DESIGN.md
// guardrail 3 allows and the same standing as .social-icon-hover / .vc-btn-*.
const BADGE_WHATSAPP_SVG =
  '<svg viewBox="0 0 24 24" class="w-6 h-6" aria-hidden="true"><circle cx="12" cy="12" r="12" fill="#25D366"/><path fill="#fff" d="M16.7 13.9c-.3-.1-1.6-.8-1.9-.9-.2-.1-.4-.1-.6.1s-.7.9-.8 1c-.2.2-.3.2-.6.1-.3-.2-1.2-.4-2.2-1.4-.8-.7-1.3-1.6-1.5-1.9-.2-.3 0-.4.1-.6l.4-.5c.1-.2.2-.3.2-.5s0-.4-.1-.5c-.1-.1-.6-1.5-.9-2.1-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.3.3-.9.9-.9 2.3s1 2.7 1.2 2.8c.1.2 2 3.1 4.9 4.3 1.8.7 2.5.8 3.3.7.6-.1 1.6-.7 1.8-1.3.2-.6.2-1.1.2-1.2-.1-.2-.3-.2-.5-.3z"/></svg>';

const BADGE_SHARE_SVG =
  '<svg viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4" aria-hidden="true"><path d="M18 16.1c-.8 0-1.5.3-2 .8l-7.1-4.2c.1-.2.1-.5.1-.7s0-.5-.1-.7L16 7.2c.5.5 1.2.8 2 .8 1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3c0 .3 0 .5.1.7L8.1 9.9c-.5-.6-1.3-.9-2.1-.9-1.7 0-3 1.3-3 3s1.3 3 3 3c.8 0 1.6-.3 2.1-.9l7.1 4.2c-.1.2-.1.4-.1.6 0 1.6 1.3 3 3 3s3-1.3 3-3-1.4-2.8-3.1-2.8z"/></svg>';

function badgeVisibilityContent(item, isMobile) {
  const isCongrats = item.type === "badge_earned";
  // trim: several merit_badges rows store the image URL with a trailing space,
  // which browsers forgive in src but not inside a CSS url().
  const iconUrl = String(
    item.badge_image || window.appconfig?.default_badge_image || ""
  ).trim();
  const icon = escapeBadgeText(iconUrl);
  // The shine mask interpolates the URL into a style attribute, where an
  // HTML-escaped quote decodes back to a real one and would close url()'s
  // string early. Drop every character that could break out instead.
  const iconCssUrl = escapeBadgeText(iconUrl.replace(/["'()\\\s]/g, ""));
  const target = parseInt(item.target_count, 10);
  const current = parseInt(item.current_count, 10);
  const progress = target > 0 ? Math.min(100, Math.round((current / target) * 100)) : 0;

  const ways = (item.ways || [])
    .map((way) => {
      const parts = badgeWayParts(way);
      return `
        <div class="relative z-[1] flex items-center gap-3">
          ${parts.icon ? `<span class="text-xl leading-none shrink-0">${escapeBadgeText(parts.icon)}</span>` : ""}
          <span class="badge-nudge-body-text text-[18px] font-bold leading-snug">${escapeBadgeText(parts.text)}</span>
        </div>`;
    })
    .join("");

  return `
    <div class="badge-nudge-card relative overflow-hidden flex flex-col items-center ${isMobile ? "pt-3" : "pt-[23px]"}">
      ${isMobile ? `<div class="badge-nudge-handle"></div>` : ""}

      <button type="button" aria-label="${escapeBadgeText(I18n.t('close'))}" class="close-modal absolute ${isMobile ? "top-[33px]" : "top-[23px]"} right-[22px] text-secondary-icon-light dark:text-secondary-icon-dark bg-transparent rounded-lg w-[14px] h-[14px] flex justify-center items-center z-20">
        <svg class="w-[14px] h-[14px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
        </svg>
      </button>

      <div id="${BADGE_VISIBILITY_TITLE_ID}" class="badge-nudge-heading relative z-[1] text-[26px] font-bold text-center break-words leading-tight px-12 ${isMobile ? "mt-4" : ""}">${escapeBadgeText(item.title)}</div>

      <div class="badge-nudge-art relative flex justify-center w-full h-[166px] ${isCongrats ? "mt-[23px]" : "mt-[14px]"}">
        ${
          icon
            ? `<span class="badge-nudge-skeleton" aria-hidden="true"></span>
               <img src="${icon}" fetchpriority="high" decoding="async" class="badge-nudge-badge-img relative z-[1] w-[144px] h-[166px] object-contain" alt="${escapeBadgeText(item.badge_name)}" />
               <span class="badge-nudge-shine" style="-webkit-mask-image:url('${iconCssUrl}');mask-image:url('${iconCssUrl}')" aria-hidden="true"></span>`
            : ""
        }
        <span class="badge-nudge-sparkle badge-nudge-sparkle-1">${BADGE_SPARKLE_SVG}</span>
        <span class="badge-nudge-sparkle badge-nudge-sparkle-2">${BADGE_SPARKLE_SVG}</span>
        <span class="badge-nudge-sparkle badge-nudge-sparkle-3">${BADGE_SPARKLE_SVG}</span>
        ${
          isCongrats
            ? `<dotlottie-player src="${BADGE_CONFETTI_LOTTIE}" background="transparent" speed="1" autoplay class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[390px] h-[390px] z-[2] pointer-events-none motion-reduce:hidden"></dotlottie-player>`
            : ""
        }
      </div>

      <div class="badge-nudge-heading relative z-[1] text-[28px] font-bold text-center break-words leading-tight px-6 ${isCongrats ? "mt-[18px]" : "mt-[9px]"}">${escapeBadgeText(item.badge_name)}</div>

      ${
        isCongrats
          ? ""
          : `<div class="relative z-[1] w-full px-[45px] mt-2">
               <div class="badge-nudge-muted-text text-[13px] font-semibold text-center">${escapeBadgeText(item.progress_text || "")}</div>
               <div class="badge-nudge-progress mt-[6px]">${
                 progress > 0
                   ? `<div class="badge-nudge-progress-fill" style="width: ${progress}%"></div>`
                   : ""
               }</div>
             </div>`
      }

      ${
        isCongrats
          ? `<div class="badge-nudge-body-text relative z-[1] text-[18px] font-medium text-center break-words leading-[25px] max-w-[300px] mt-[11px] mb-8">${badgeMessageMarkup(item)}</div>`
          : `<div class="badge-nudge-muted-text relative z-[1] text-[17px] font-semibold text-center break-words leading-snug max-w-[300px] mt-[14px] mb-[17px]">${escapeBadgeText(item.message)}</div>`
      }

      <div class="badge-nudge-panel relative z-[1] w-full pt-5 px-[30px] pb-6 flex flex-col">
        ${
          isCongrats
            ? `<div class="badge-nudge-muted-text text-[17px] font-semibold text-center">${escapeBadgeText(item.share_label)}</div>
               <div class="flex items-center justify-center gap-[12px] mt-4">
                 <a class="badge-visibility-share-intent badge-nudge-chip badge-nudge-chip--whatsapp pressable" data-network="whatsapp" href="#" target="_blank" rel="noopener noreferrer">
                   ${BADGE_WHATSAPP_SVG}
                   <span class="text-sm">WhatsApp</span>
                 </a>
                 <button type="button" class="badge-visibility-share badge-nudge-chip badge-nudge-chip--more cursor-pointer pressable">
                   ${BADGE_SHARE_SVG}
                   <span class="text-sm">${escapeBadgeText(item.share_more_label || I18n.t('more'))}</span>
                 </button>
               </div>`
            : ways
              ? `<div class="badge-nudge-ways-title self-start text-base font-bold px-4 py-2 rounded-bradius10">${escapeBadgeText(item.ways_title || "")}</div>
                 <div class="flex flex-col gap-[16px] mt-[11px]">${ways}</div>`
              : ""
        }
        <button type="button" class="badge-visibility-cta orange-btn text-center font-bold h-14 px-4 text-[17px] flex items-center justify-center ${isCongrats ? "mt-[21px]" : "mt-[22px]"}">${escapeBadgeText(item.cta_label)}</button>
      </div>
    </div>
  `;
}

// Both frames put the popup at 390px wide - the desktop variant is the same
// card centred over a scrim, not a wider one. The design's 28px radius is not
// a brand radius, so the card takes bradius10 and the sheet the 20px top
// radius every other bottom drawer in the app uses.
function badgeVisibilityMarkup(item, isMobile) {
  const content = badgeVisibilityContent(item, isMobile);

  // max-h-[90vh]: the nudge variant is ~640px tall, which overflows a short
  // phone viewport. Without the cap the sheet extends past the top of the
  // screen and the title is unreachable, since the sheet is pinned to the
  // bottom edge and cannot be scrolled into view.
  if (isMobile) {
    return `<div id="badge-drawer" style="display:none" class="overflow-hidden fixed bottom-0 left-0 right-0 z-[800] w-full max-h-[90vh] rounded-t-[20px] overflow-y-auto bg-white dark:bg-background-dark translate-y-[100%] transition-transform" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="${BADGE_VISIBILITY_TITLE_ID}">
        ${content}
      </div>`;
  }

  // items-start + my-auto rather than items-center: the card centres while it
  // fits, and anchors to the top once it is taller than the viewport, so its
  // heading never ends up scrolled off above the scroll container.
  return `<div id="badge-modal" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="${BADGE_VISIBILITY_TITLE_ID}" class="fixed inset-0 z-[800] hidden w-full h-full p-4 overflow-x-hidden overflow-y-auto items-start justify-center">
      <div class="relative w-full max-w-[390px] my-auto mx-auto">
          <div class="relative w-[390px] max-w-full mx-auto rounded-bradius10 overflow-hidden shadow-custom-4">
            ${content}
          </div>
      </div>
    </div>`;
}
// The server sends an absolute profile URL, or a bare path when it could not
// resolve a host. Normalise so no share path ever emits a relative link.
function badgeShareUrl(item) {
  return new URL(item.share_url, window.location.origin).href;
}

function badgeShareMessage(item) {
  return `${item.share_text} ${badgeShareUrl(item)}`;
}

function shareIntentUrl(network, item) {
  const url = badgeShareUrl(item);
  if (network === "whatsapp") {
    return `https://api.whatsapp.com/send?text=${encodeURIComponent(badgeShareMessage(item))}`;
  }
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
}

function trackBadgeShare(item, method) {
  trackBadgeEvent("badge_share_clicked", {
    badge_name: item.badge_name,
    record_type: item.record_type,
    method: method
  });
}

// Web Share API where available, clipboard + toast everywhere else.
async function shareBadgeVisibility(item) {
  trackBadgeShare(item, navigator.share ? "web_share" : "clipboard");

  const shareUrl = badgeShareUrl(item);
  const message = badgeShareMessage(item);

  if (navigator.share) {
    try {
      await navigator.share({ text: item.share_text, url: shareUrl });
      return;
    } catch (error) {
      // The user dismissing the share sheet is a deliberate choice - respect it.
      // Any other failure (API present but unusable, as in some in-app and
      // desktop browsers) falls through to the clipboard path below, so the
      // button is never a dead end.
      if (error && error.name === "AbortError") return;
    }
  }

  try {
    await navigator.clipboard.writeText(message);
    showToast(item.share_copied_message);
  } catch (error) {
    // Clipboard blocked (insecure context or denied permission) - nothing left
    // to try, and a failed share must never break the modal.
  }
}

// Short re-check after the AJAX actions that can move a Phase-1 count:
// a comment posted to .../posts, or a post upvote. Debounced so a burst of
// actions collapses into one call, and never more than one request in flight.
function bindBadgeVisibilityRecheck() {
  // Same guard the delegated listeners above use, so calling init more than
  // once cannot stack duplicate listeners (and duplicate re-check requests).
  if (window._badgeVisibilityDelegated) return;
  window._badgeVisibilityDelegated = true;

  document.addEventListener("ajax:success", (event) => {
    const el = event.target;
    if (!el || typeof el.getAttribute !== "function") return;
    const url = el.getAttribute("action") || el.getAttribute("href") || "";
    if (/\/posts(\?|$)/.test(url) || /\/posts\/voteup/.test(url)) {
      scheduleBadgeVisibilityRecheck();
    }
  });

  // The votes that move a Phase-1 count on this page do NOT emit ajax:success:
  // deal votes go through voteup_votedown.js (.topic_vote_up/.topic_vote_down,
  // href="javascript:void(0)") and desktop post Likes through
  // comment_actions.js (.reaction-list), both via fetchAPI. .reaction-icon is
  // data-remote and so is already covered above, but is listed here too so the
  // vote trigger does not depend on which path fired first. A click that only
  // opens the mobile reaction drawer costs one debounced no-op GET, which is
  // far cheaper than missing the vote entirely.
  document.addEventListener("click", (event) => {
    const el = event.target.closest &&
      event.target.closest(".topic_vote_up, .topic_vote_down, .reaction-icon, .reaction-list");
    if (el) scheduleBadgeVisibilityRecheck();
  });
}

function scheduleBadgeVisibilityRecheck() {
  if (badgeVisibilityRecheckInFlight) return;
  clearTimeout(badgeVisibilityRecheckTimer);
  badgeVisibilityRecheckTimer = setTimeout(runBadgeVisibilityRecheck, BADGE_VISIBILITY_RECHECK_DELAY);
}

async function runBadgeVisibilityRecheck() {
  badgeVisibilityRecheckInFlight = true;
  try {
    // POST + CSRF token: the endpoint consumes queued nudges, so a cross-site
    // GET must not be able to trigger it.
    const csrfMeta = document.querySelector('meta[name="csrf-token"]');
    const response = await fetch("/badge_visibility", {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfMeta ? csrfMeta.getAttribute("content") : "",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json"
      },
      credentials: "same-origin"
    });
    if (response.ok) {
      const data = await response.json();
      enqueueBadgeVisibility(data.items);
    }
  } catch (error) {
    // Best effort - the nudge simply shows on the next page load instead.
  } finally {
    badgeVisibilityRecheckInFlight = false;
  }
}

// Make functions globally available
window.setBadgePopup = setBadgePopup;
window.userSelectionStore = userSelectionStore;
window.initBadgeVisibility = initBadgeVisibility;

export { setBadgePopup, initBadgeVisibility };